module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Cursor-8f06f45616173e378deae872f0e910d5.svg";